import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../theme/modern/touchTargets"

export default makeStyles((theme: ModernTheme) => ({

    trigger: {
        display: "inline-flex",
        maxWidth: "100%",

        "&:focus": {
            outline: `2px solid ${theme.modern.accent}`,
            outlineOffset: 2,
            borderRadius: 999,
        },
        "&:focus:not(:focus-visible)": {outline: "none"},

        [COARSE]: {
            position: "relative",
            WebkitTapHighlightColor: "transparent",
            touchAction: "manipulation",

            "&::after": {
                content: "''",
                position: "absolute",
                left: 0,
                right: 0,
                top: "50%",
                height: TOUCH_MIN,
                transform: "translateY(-50%)",
            },
        },
    },

    tip: {
        position: "fixed",
        zIndex: 1250,
        maxWidth: 340,
        "@media (max-width:355px)": {maxWidth: "calc(100vw - 16px)"},
        padding: "8px 11px",
        borderRadius: 9,
        background: theme.modern.panel,
        color: theme.modern.ink,
        border: `1px solid ${theme.modern.line}`,
        boxShadow: theme.modern.shadowHover,
        font: `500 11.5px/1.55 ${theme.modern.sans}`,
        whiteSpace: "pre-line",
        overflowWrap: "break-word",
        pointerEvents: "none",
        animation: "$tip_in .13s ease-out",
    },
    tip__measuring: {
        visibility: "hidden",
        left: 0,
        top: 0,
        animation: "none",
    },

    arrow: {
        position: "absolute",
        width: 8,
        height: 8,
        background: theme.modern.panel,
        borderLeft: `1px solid ${theme.modern.line}`,
        borderTop: `1px solid ${theme.modern.line}`,
    },
    arrow__below: {
        top: -5,
        transform: "rotate(45deg)",
    },
    arrow__above: {
        bottom: -5,
        transform: "rotate(225deg)",
    },

    "@keyframes tip_in": {
        from: {opacity: 0},
        to: {opacity: 1},
    },
}));
